/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Poweredbystreamboxyenabled3Inputs */

const en_entity_poweredbystreamboxyenabled3 = /** @type {(inputs: Entity_Poweredbystreamboxyenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by Streamboxy Enabled`)
};

const de_entity_poweredbystreamboxyenabled3 = /** @type {(inputs: Entity_Poweredbystreamboxyenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by Streamboxy aktiviert`)
};

/**
* | output |
* | --- |
* | "Powered by Streamboxy Enabled" |
*
* @param {Entity_Poweredbystreamboxyenabled3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_poweredbystreamboxyenabled3 = /** @type {((inputs?: Entity_Poweredbystreamboxyenabled3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Poweredbystreamboxyenabled3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_poweredbystreamboxyenabled3(inputs)
	return de_entity_poweredbystreamboxyenabled3(inputs)
});
export { entity_poweredbystreamboxyenabled3 as "entity_poweredByStreamboxyEnabled" }